<template>
  <v-text-field
    :value="price"
    @input="value => updatePrice(value)"
    type="number"
    :label="config.label"
    :name="config.key"
    :required="config.required"
    :id="config.key"
    :error="haveErrors()"
    :rules="config.errors"
    :hint="config.hint"
    :suffix="platform.currency"
    pattern="[0-9]+([,\.][0-9]+)?"
    :min="config.min || 0"
    :max="config.max ? config.max / 100 : null"
    step="0.01"
    :readonly="config.disabled">
  </v-text-field>
</template>

<script>
  import { mapGetters } from 'vuex'
  import input from '@/mixins/input'

  export default {
    mixins: [input],
    data () {
      return {
        price: typeof this.value === 'number' ? (this.value / 100).toFixed(2) : null
      }
    },
    computed: mapGetters({
      platform: 'skiliko/session/currentPlatform'
    }),
    methods: {
      updatePrice (value) {
        const cents = Math.round(parseFloat(value) * 100)
        this.price = cents / 100
        this.emit(cents)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/Price.vue